export const API_URL = 'https://sportchat.idantech.co.il/api/translation-web/';
